import OrdersTab from './OrdersTab';
import Components from './components';

export default { OrdersTab, Components };
